routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.page', {
      url: "page/{pageSlug}",
      template: `<page sh-ctrl="shCtrl"></page>`
    });
}

export default routesConfig;



// WEBPACK FOOTER //
// ./www/components/page/page.config.js